import axios from 'axios';
import { V1API } from '../../../_helpers/APIPath';
import { encode, decode } from '../../dataMagic';
import { populateStore, performNetworkCall, buildFormData } from '@/store/asyncHelper';



const mutations = {};
const store = {};

populateStore(store, mutations, false);

export default {
    namespaced: true,

    state : {
        initiatives: [],
        initiativeLoading: false,
        initiativeError: false,

        ...store
    },

    mutations : {
        ...mutations,

        SET_INITIATIVE (state, items) {
            state.initiatives = items;
        },

        INITIATIVE_LOADING (state, loading) {
            state.initiativeLoading = loading;
        },

        INITIATIVE_ERROR (state, hasError) {
            state.initiativeError = hasError;
        }
    },

    actions: {
        async fetchInitiativeList ({ commit }) {
            commit('INITIATIVE_LOADING', true);
            commit('INITIATIVE_ERROR', false);

            let config = {
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                }
            };

            try{
                let result = await axios.get(V1API.initiative_list, config);
                let response = result.data;

                commit('SET_INITIATIVE', response.results);

            } catch(error) {
                commit('INITIATIVE_ERROR', true);
            } finally {
                commit('INITIATIVE_LOADING', false);
            }
        },

        async deleteInitiative({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.delete(V1API.initiative_delete + payload.delete_value, config).then(result=>{
                let data = result.data
                return data
            })

            dispatch ('fetchInitiativeList')
            return response
        },

        async updateStatusToggle({ commit, dispatch }, payload) {
            let config = {
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                }
            };
            console.log(payload.delete);
            let response = await axios.get(V1API.initiative_status_toggle + payload.initiative_id, config).then(result=>{
                let data = result.data;
                return data;
            });

            dispatch ('fetchInitiativeList');

            return response;
        }
    },

    getters: {}
};
